"use client";

import React, { useState, useEffect, useRef, useCallback } from "react";
import { supabase } from "../supabase/client";
import { 
  Plus, Search, Trash2, Edit3, X, Save, Package, 
  Loader2, PlusCircle, MinusCircle, Eye, EyeOff
} from "lucide-react";

export default function Products() {
  const [categories, setCategories] = useState([]);

useEffect(() => {
  fetchCategories();
}, []);

  const sizeTypes = ["Bra Size", "Panty Size", "Standard (S/M/L)", "Waist Size"];

  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [extraImagesFiles, setExtraImagesFiles] = useState([]);
  const [editingProduct, setEditingProduct] = useState(null);

  const initialForm = {
    title: "", brand: "", material: "", 
    size_type: "Standard (S/M/L)", price: "", discounted_price: "", cost_price: "",
  profit_percent: "",
    description: "", category_id: "", bestseller_priority: 0, is_visible: true,
  is_bestseller: false
  };
  const [form, setForm] = useState(initialForm);
  const [variants, setVariants] = useState([
  {
    color: "",
    image: null,
    preview: null,
    sizes: [
      { size: "", stock: 0 }
    ]
  }
]);

  const fileInputRef = useRef(null);
  const extraFilesRef = useRef(null);
  const [mainImageFile, setMainImageFile] = useState(null);
  const [mainImagePreview, setMainImagePreview] = useState(null);
  const [existingExtraImages, setExistingExtraImages] = useState([]);

  useEffect(() => { loadProducts(); }, []);

  async function loadProducts() {
    setLoading(true);
    const { data, error } = await supabase
      .from("products")
      .select(`*, product_variants(*), product_images(*)`)
      .order("created_at", { ascending: false });
    if (!error) setProducts(data || []);
    setLoading(false);
  }

  async function fetchCategories() {
  const { data, error } = await supabase
    .from('categories')
    .select('*')
    .order('name', { ascending: true }); // Optional: Alphabetical order

  if (error) {
    console.error('Error fetching categories:', error);
  } else {
    setCategories(data);
  }
}

  const openEditModal = (p) => {
    setEditingProduct(p);
    setForm({
      title: p.title || "",
      brand: p.brand || "",
      material: p.material || "",
      size_type: p.size_type || "Standard (S/M/L)",
      price: p.price || "",
      discounted_price: p.discounted_price || "",
      cost_price: p.cost_price || "",
  profit_percent: p.profit_percent || "",
      description: p.description || "",
      category_id: p.category_id || "",
      bestseller_priority: p.bestseller_priority || 0,
      is_visible: p.is_visible !== undefined ? p.is_visible : true,
      is_bestseller: p.is_bestseller !== undefined ? p.is_bestseller : false
    });
    
    if (p.product_variants && p.product_variants.length > 0) {
  const grouped = {};

  p.product_variants.forEach(v => {
    const key = v.color || "default";

    if (!grouped[key]) {
      grouped[key] = {
        color: v.color || "",
        image: null,
        preview: v.color_image_url || null,
        sizes: []
      };
    }

    grouped[key].sizes.push({
      size: v.size,
      stock: v.stock_quantity
    });
  });

  setVariants(Object.values(grouped));
} else {
      setVariants([{ size: "", color: "", stock: 0, image: null, preview: null }]);
    }

    setMainImagePreview(p.main_image_url);
    setExistingExtraImages(p.product_images || []);
    setShowModal(true);
  };

  const closeAndReset = () => {
    setShowModal(false);
    setEditingProduct(null);
    setForm(initialForm);
    setVariants([{ size: "", color: "", stock: 0, image: null, preview: null }]);
    setMainImageFile(null);
    setMainImagePreview(null);
    setExtraImagesFiles([]);
    setExistingExtraImages([]);
  };

  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMainImageFile(file);
      setMainImagePreview(URL.createObjectURL(file));
    }
  };

  const handleExtraImagesChange = (e) => {
    if (e.target.files) {
      setExtraImagesFiles([...extraImagesFiles, ...Array.from(e.target.files)]);
    }
  };

  const addColorGroup = () => {
  setVariants([
    ...variants,
    {
      color: "",
      image: null,
      preview: null,
      sizes: [{ size: "", stock: 0 }]
    }
  ]);
};

const addSizeToColor = (colorIndex) => {
  const nv = [...variants];
  nv[colorIndex].sizes.push({ size: "", stock: 0 });
  setVariants(nv);
};

const removeColorGroup = (index) => {
  setVariants(variants.filter((_, i) => i !== index));
};

const removeSizeRow = (colorIndex, sizeIndex) => {
  const nv = [...variants];
  nv[colorIndex].sizes = nv[colorIndex].sizes.filter((_, i) => i !== sizeIndex);
  setVariants(nv);
};

const handleColorImageChange = (e, index) => {
  const file = e.target.files[0];
  if (!file) return;

  const nv = [...variants];
  nv[index].image = file;
  nv[index].preview = URL.createObjectURL(file);
  setVariants(nv);
};


const calculateSellingPrice = useCallback(() => {
  const cost = Number(form.cost_price);
  const percent = Number(form.profit_percent);

  if (!cost || !percent) return "";

  return (cost + (cost * percent) / 100).toFixed(2);
}, [form.cost_price, form.profit_percent]);

const calculateFinalProfitPercent = () => {
  const cost = Number(form.cost_price);
  const base = Number(form.price);
  const discount = Number(form.discounted_price);

  if (!cost) return 0;

  // Use discounted price if available
  const selling = discount || base;

  if (!selling) return 0;

  return (((selling - cost) / cost) * 100).toFixed(2);
};

const calculateFinalProfitAmount = () => {
  const cost = Number(form.cost_price);
  const base = Number(form.price);
  const discount = Number(form.discounted_price);

  if (!cost) return 0;

  const selling = discount || base;

  if (!selling) return 0;

  return (selling - cost).toFixed(2);
};

const calculateBaseProfitPercent = () => {
  const cost = Number(form.cost_price);
  const base = Number(form.price);

  if (!cost || !base) return 0;

  return (((base - cost) / cost) * 100).toFixed(2);
};

useEffect(() => {
  const sellingPrice = calculateSellingPrice();

  if (sellingPrice && sellingPrice !== form.price) {
    setForm(prev => ({ ...prev, price: sellingPrice }));
  }
}, [calculateSellingPrice, form.price]);

  

  const uploadImage = async (file, path) => {
    const { error } = await supabase.storage
      .from("cms-media")
      .upload(path, file, { upsert: true });
    if (error) throw error;
    const { data: urlData } = supabase.storage.from("cms-media").getPublicUrl(path);
    return urlData.publicUrl;
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const timestamp = Date.now();
      const slugBase = `${form.brand}-${form.title}`.toLowerCase().replace(/[^a-z0-9]+/g, "-");
      const slug = editingProduct ? editingProduct.slug : `${slugBase}-${timestamp}`;

      let mainImageUrl = editingProduct?.main_image_url || null;
      if (mainImageFile) {
        const ext = mainImageFile.name.split('.').pop();
        const path = `products/${slug}/main-${timestamp}.${ext}`;
        mainImageUrl = await uploadImage(mainImageFile, path);
      }

      const productPayload = {
  title: form.title,
  brand: form.brand,
  slug: slug,
  price: Number(form.price),
  discounted_price: form.discounted_price
    ? Number(form.discounted_price)
    : null,

  // ✅ NEW FIELDS
  cost_price: form.cost_price ? Number(form.cost_price) : null,
  profit_percent: form.profit_percent ? Number(form.profit_percent) : null,

  description: form.description,
  category_id: form.category_id,
  material: form.material,
  size_type: form.size_type,
  main_image_url: mainImageUrl,
  bestseller_priority: Number(form.bestseller_priority) || 0,
  is_visible: form.is_visible,
  is_bestseller: form.is_bestseller,
};

      let productId = editingProduct?.id;

      if (editingProduct) {
        const { error: updateError } = await supabase.from("products").update(productPayload).eq("id", productId);
        if (updateError) throw updateError;
        await supabase.from("product_variants").delete().eq("product_id", productId);
      } else {
        const { data, error: pError } = await supabase.from("products").insert([productPayload]).select().single();
        if (pError) throw pError;
        productId = data.id;
      }

      if (extraImagesFiles.length > 0) {
        const extraImageData = [];
        for (let i = 0; i < extraImagesFiles.length; i++) {
          const file = extraImagesFiles[i];
          const ext = file.name.split('.').pop();
          const path = `products/${slug}/extra-${timestamp}-${i}.${ext}`;
          const url = await uploadImage(file, path);
          extraImageData.push({ product_id: productId, image_url: url, alt_text: form.title });
        }
        await supabase.from("product_images").insert(extraImageData);
      }

      const variantData = [];

for (let i = 0; i < variants.length; i++) {
  const group = variants[i];

  let imageUrl = group.preview || null;

  if (group.image) {
    const ext = group.image.name.split('.').pop();
    const path = `products/${slug}/color-${i}-${Date.now()}.${ext}`;
    imageUrl = await uploadImage(group.image, path);
  }

  for (let j = 0; j < group.sizes.length; j++) {
    const s = group.sizes[j];

    variantData.push({
      product_id: productId,
      size: s.size || "N/A",
      color: group.color || null,
      stock_quantity: Number(s.stock) || 0,
      color_image_url: imageUrl,
      sku: `${slug}-${(group.color || "no-color").replace(/[^a-z0-9]/gi, '')}-${s.size}-${j}`
    });
  }
}

await supabase.from("product_variants").insert(variantData);

      closeAndReset();
      loadProducts();
    } catch (error) {
      alert("Error saving product: " + error.message);
    } finally {
      setSaving(false);
    }
  };

  const deleteProduct = async (id) => {
    if (window.confirm("Delete this product permanently?")) {
      const { error } = await supabase.from("products").delete().eq("id", id);
      if (error) alert(error.message);
      loadProducts();
    }
  };

  const deleteExtraImage = async (imageId) => {
    if (window.confirm("Remove this image?")) {
      const { error } = await supabase.from("product_images").delete().eq("id", imageId);
      if (!error) {
        setExistingExtraImages(existingExtraImages.filter(img => img.id !== imageId));
      }
    }
  }

  const updateProductVisibility = async (productId, newStatus) => {
  try {
    const { error } = await supabase
      .from('products')
      .update({ is_visible: newStatus })
      .eq('id', productId);

    if (error) throw error;

    // Update local state so the UI changes immediately
    setProducts(products.map(p => 
      p.id === productId ? { ...p, is_visible: newStatus } : p
    ));
    
  } catch (error) {
    console.error("Error updating visibility:", error.message);
    alert("Failed to update visibility");
  }
}; 

  return (
    <div className="min-h-screen bg-slate-50/50 p-4 md:p-8 text-slate-900 font-sans">
      <div className="max-w-7xl mx-auto">
        
        {/* --- TOP BAR --- */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Product Catalog</h1>
            <p className="text-slate-500 text-sm">Manage inventory, pricing, and variants.</p>
          </div>
          <div className="flex gap-3">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input 
                type="text" 
                placeholder="Search products..." 
                className="pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-indigo-500 transition-all outline-none w-64"
                value={search} 
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <button 
              onClick={() => setShowModal(true)} 
              className="bg-indigo-600 text-white px-5 py-2 rounded-xl text-sm font-semibold flex items-center gap-2 hover:bg-indigo-700 shadow-sm transition-all shadow-indigo-200"
            >
              <Plus size={18} /> Add Product
            </button>
          </div>
        </div>

        {/* --- PRODUCT TABLE --- */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50/50 border-b border-slate-100">
                <th className="px-6 py-4 text-[11px] font-bold uppercase tracking-wider text-slate-500">Product</th>
                <th className="px-6 py-4 text-[11px] font-bold uppercase tracking-wider text-slate-500">Category</th>
                <th className="px-6 py-4 text-[11px] font-bold uppercase tracking-wider text-slate-500">Pricing</th>
                <th className="px-6 py-4 text-[11px] font-bold uppercase tracking-wider text-slate-500">Stock Status</th>
                <th className="px-6 py-4 text-[11px] font-bold uppercase tracking-wider text-slate-500 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {loading ? (
                <tr><td colSpan="5" className="py-20 text-center"><Loader2 className="animate-spin mx-auto text-indigo-500" /></td></tr>
              ) : products.filter(p => p.title.toLowerCase().includes(search.toLowerCase())).map(product => (
                <tr key={product.id} className="hover:bg-slate-50/80 transition-colors group">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 rounded-lg border border-slate-200 overflow-hidden bg-slate-100">
                        <img src={product.main_image_url || 'https://via.placeholder.com/50'} className="w-full h-full object-cover" alt="" />
                      </div>
                      <div>
                        <div className="font-bold text-slate-900 text-sm">{product.title}</div>
                        <div className="text-xs text-slate-400">{product.brand}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className="px-2.5 py-1 bg-slate-100 rounded-md text-[10px] font-bold text-slate-600 uppercase tracking-tight">
                      {categories.find(c => c.id === product.category_id)?.name || "Uncategorized"}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm font-bold">৳{product.price.toFixed(2)}</div>
                    {product.discounted_price && (
                      <div className="text-[15px] text-emerald-600 font-bold">Sale: ৳{product.discounted_price.toFixed(2)}</div>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex flex-wrap gap-1.5">
                      {product.product_variants?.slice(0, 3).map((v, i) => (
                        <div key={i} className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold border ${
                          v.stock_quantity > 10 ? 'bg-indigo-50 border-indigo-100 text-indigo-600' : 'bg-orange-50 border-orange-100 text-orange-600'
                        }`}>
                          {v.size}: {v.stock_quantity}
                        </div>
                      ))}
                      {product.product_variants?.length > 3 && <span className="text-[10px] text-slate-400 mt-0.5">+{product.product_variants.length - 3} more</span>}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-2 opacity-80 group-hover:opacity-100 transition-opacity">
                      <button 
    onClick={() => updateProductVisibility(product.id, !product.is_visible)} 
    className={`p-2 rounded-lg transition-all shadow-sm ${
      product.is_visible 
        ? 'bg-emerald-50 text-emerald-600 hover:bg-emerald-100' 
        : 'bg-slate-100 text-slate-400 hover:bg-slate-200'
    }`}
    title={product.is_visible ? "Visible on Store" : "Hidden from Store"}
  >
    {product.is_visible ? <Eye size={16}/> : <EyeOff size={16}/>}
  </button>
                      <button onClick={() => openEditModal(product)} className="p-2 hover:bg-indigo-50 hover:text-indigo-600 rounded-lg transition-colors"><Edit3 size={16}/></button>
                      <button onClick={() => deleteProduct(product.id)} className="p-2 hover:bg-red-50 text-slate-400 hover:text-red-600 rounded-lg transition-colors"><Trash2 size={16}/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* --- MODAL DESIGN --- */}
        {showModal && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm">
            <div className="bg-white rounded-[32px] w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col shadow-2xl border border-white/20">
              
              <div className="px-8 py-6 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
                <div>
                  <h2 className="text-xl font-bold text-slate-900">{editingProduct ? "Edit Product Details" : "Create New Product"}</h2>
                  <p className="text-xs text-slate-500 mt-1 uppercase tracking-widest font-semibold">{editingProduct ? `ID: ${editingProduct.id.slice(0,8)}` : "Internal Inventory System"}</p>
                </div>
                <button onClick={closeAndReset} className="p-2 hover:bg-slate-200 rounded-full transition-colors text-slate-400"><X size={24} /></button>
              </div>

              <form onSubmit={handleSubmit} className="p-8 overflow-y-auto custom-scrollbar bg-white">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                  
                  {/* Left Column: Core Info */}
                  <div className="lg:col-span-7 space-y-8">
                    <div className="space-y-4">
                      <h3 className="text-xs font-bold text-indigo-500 uppercase tracking-widest flex items-center gap-2">
                        <Package size={14}/> General Information
                      </h3>
                      <div className="grid grid-cols-2 gap-4">
                        <div className="col-span-2">
                          <label className="text-[11px] font-bold text-slate-500 mb-1.5 block px-1">Product Title</label>
                          <input required className="w-full bg-slate-50 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" value={form.title} onChange={e => setForm({...form, title: e.target.value})} placeholder="e.g. Silk Lace Bralette" />
                        </div>
                        <div>
                          <label className="text-[11px] font-bold text-slate-500 mb-1.5 block px-1">Brand</label>
                          <input required className="w-full bg-slate-50 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" value={form.brand} onChange={e => setForm({...form, brand: e.target.value})} placeholder="Brand Name" />
                        </div>
                        <div>
  <label className="text-[11px] font-bold text-slate-500 mb-1.5 block px-1 uppercase tracking-wider">
    Category
  </label>
  <div className="relative group">
    <select 
      required 
      className="w-full bg-slate-50 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500 outline-none appearance-none cursor-pointer transition-all hover:bg-slate-100" 
      value={form.category_id} 
      onChange={e => setForm({...form, category_id: e.target.value})}
    >
      <option value="">
        {categories.length === 0 ? "Loading categories..." : "Select Category"}
      </option>
      
      {categories.map(c => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
    </select>
    
    {/* Custom Dropdown Arrow (Since appearance-none is used) */}
    <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400 group-focus-within:text-indigo-500">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <path d="m6 9 6 6 6-6"/>
      </svg>
    </div>
  </div>
</div>
                      </div>
                      <div className="col-span-full">
  <label className="text-[11px] font-bold text-slate-500 mb-1.5 block px-1">
    Product Description
  </label>
  <textarea 
    className="w-full bg-slate-50 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500 outline-none h-32 resize-none" 
    value={form.description} 
    onChange={e => setForm({...form, description: e.target.value})}
    placeholder="Write a detailed product description..."
  />
</div>
                    </div>

                    <div className="space-y-4">
  <h3 className="text-xs font-bold text-indigo-500 uppercase tracking-widest">
    Smart Pricing
  </h3>

  <div className="grid grid-cols-2 gap-4">

    {/* COST PRICE */}
    <div>
      <label className="text-[11px] font-bold text-slate-500 mb-1 block">
        Buying Price
      </label>
      <input
        type="number"
        className="w-full bg-slate-50 rounded-xl p-3 text-sm"
        value={form.cost_price}
        onChange={(e) =>
          setForm({ ...form, cost_price: e.target.value })
        }
      />
    </div>

    {/* PROFIT % */}
    <div>
      <label className="text-[11px] font-bold text-slate-500 mb-1 block">
        Profit %
      </label>
      <input
        type="number"
        className="w-full bg-slate-50 rounded-xl p-3 text-sm"
        value={form.profit_percent}
        onChange={(e) =>
          setForm({ ...form, profit_percent: e.target.value })
        }
      />
    </div>

    {/* SELLING PRICE */}
    <div>
      <label className="text-[11px] font-bold text-slate-500 mb-1 block">
        Selling Price
      </label>
      <input
        type="number"
        className="w-full bg-slate-100 rounded-xl p-3 text-sm font-bold"
        value={form.price}
        onChange={(e) =>
          setForm({ ...form, price: e.target.value })
        }
      />
    </div>

    {/* DISCOUNT PRICE */}
    <div>
      <label className="text-[11px] font-bold text-slate-500 mb-1 block">
        Discount Price
      </label>
      <input
        type="number"
        className="w-full bg-slate-50 rounded-xl p-3 text-sm"
        value={form.discounted_price}
        onChange={(e) =>
          setForm({ ...form, discounted_price: e.target.value })
        }
      />
    </div>
  </div>

  {/* LIVE STATS */}
  <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-3 text-xs space-y-1">

  {/* Profit BEFORE discount */}
  <div className="flex justify-between">
    <span className="text-slate-500">Profit (Base)</span>
    <span className="font-bold text-indigo-600">
      {calculateBaseProfitPercent()}%
    </span>
  </div>

  {/* Profit AFTER discount */}
  <div className="flex justify-between">
  <span className="text-slate-500">Final Profit</span>
  <div className="text-right">
    <div className="font-bold text-emerald-600">
      {calculateFinalProfitPercent()}%
    </div>
    <div className="text-[10px] text-slate-600">
      ৳ {calculateFinalProfitAmount()}
    </div>
  </div>
</div>

</div>
</div>
<div className="flex gap-6 mt-4">
  <label className="flex items-center gap-2 text-xs font-bold">
    <input
      type="checkbox"
      checked={form.is_visible}
      onChange={(e) => setForm({ ...form, is_visible: e.target.checked })}
    />
    Visible
  </label>

  <label className="flex items-center gap-2 text-xs font-bold">
    <input
      type="checkbox"
      checked={form.is_bestseller}
      onChange={(e) => setForm({ ...form, is_bestseller: e.target.checked })}
    />
    Bestseller
  </label>
</div>

                    <div>
  <label className="text-[11px] font-bold text-slate-500 mb-1.5 block px-1">
    Size System
  </label>
  <select 
    className="w-full bg-slate-50 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500 outline-none appearance-none" 
    value={form.size_type} 
    onChange={e => setForm({...form, size_type: e.target.value})}
  >
    {sizeTypes.map(t => (
      <option key={t} value={t}>{t}</option>
    ))}
  </select>
</div>

                    {/* Variants Section */}
                    <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100">
  <div className="flex justify-between items-center mb-4">
    <h3 className="text-xs font-bold text-slate-900 uppercase tracking-widest">
      Inventory Matrix
    </h3>

    <button
      type="button"
      onClick={addColorGroup}
      className="text-indigo-600 text-[11px] font-bold flex items-center gap-1 hover:underline"
    >
      <PlusCircle size={14} /> Add Color
    </button>
  </div>

  <div className="space-y-4">
    {variants.map((group, colorIndex) => (
      <div key={colorIndex} className="bg-white p-4 rounded-xl border border-slate-200 space-y-3">

        {/* COLOR ROW */}
        <div className="flex items-center gap-3">
          <input
            placeholder="Color (e.g. Red)"
            className="bg-transparent border-none text-sm font-bold flex-1 outline-none"
            value={group.color}
            onChange={(e) => {
              const nv = [...variants];
              nv[colorIndex].color = e.target.value;
              setVariants(nv);
            }}
          />

          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleColorImageChange(e, colorIndex)}
            className="text-[10px] w-32"
          />

          {group.preview && (
            <img src={group.preview} alt="Variant preview" className="w-10 h-10 object-cover rounded-md border" />
          )}

          <button
            type="button"
            onClick={() => removeColorGroup(colorIndex)}
            className="text-slate-300 hover:text-red-500"
          >
            <MinusCircle size={18} />
          </button>
        </div>

        {/* SIZE ROWS */}
        <div className="space-y-2">
          {group.sizes.map((s, sizeIndex) => (
            <div key={sizeIndex} className="flex gap-2 items-center">

              <input
                placeholder="Size"
                className="bg-slate-50 rounded-lg px-2 py-1 text-xs w-24"
                value={s.size}
                onChange={(e) => {
                  const nv = [...variants];
                  nv[colorIndex].sizes[sizeIndex].size = e.target.value;
                  setVariants(nv);
                }}
              />

              <input
                type="number"
                placeholder="Stock"
                className="bg-slate-50 rounded-lg px-2 py-1 text-xs w-20 font-bold"
                value={s.stock}
                onChange={(e) => {
                  const nv = [...variants];
                  nv[colorIndex].sizes[sizeIndex].stock = e.target.value;
                  setVariants(nv);
                }}
              />

              <button
                type="button"
                onClick={() => removeSizeRow(colorIndex, sizeIndex)}
                className="text-slate-300 hover:text-red-500"
              >
                <MinusCircle size={14} />
              </button>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={() => addSizeToColor(colorIndex)}
          className="text-indigo-600 text-[11px] font-bold flex items-center gap-1 hover:underline"
        >
          <PlusCircle size={14} /> Add Size
        </button>

      </div>
    ))}
  </div>
</div>
                  </div>

                  {/* Right Column: Media */}
                  <div className="lg:col-span-5 space-y-8">
                    <div className="space-y-4">
                      <h3 className="text-xs font-bold text-indigo-500 uppercase tracking-widest">Main Display Asset</h3>
                      <div className="relative group aspect-square rounded-3xl overflow-hidden border-2 border-dashed border-slate-200 bg-slate-50 flex items-center justify-center">
                        {mainImagePreview ? (
                          <>
                            <img src={mainImagePreview} className="w-full h-full object-cover" alt="Main product" />
                            <div className="absolute inset-0 bg-indigo-900/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                               <button type="button" onClick={() => fileInputRef.current.click()} className="bg-white text-indigo-600 px-4 py-2 rounded-xl text-xs font-bold shadow-lg">Replace Media</button>
                            </div>
                          </>
                        ) : (
                          <button type="button" onClick={() => fileInputRef.current.click()} className="flex flex-col items-center gap-2 text-slate-400">
                            <div className="p-4 bg-white rounded-full shadow-sm border border-slate-100 text-indigo-500"><Plus size={32}/></div>
                            <span className="text-xs font-bold">Upload Principal Image</span>
                          </button>
                        )}
                        <input type="file" ref={fileInputRef} hidden onChange={handleMainImageChange} />
                      </div>
                    </div>

                    <div className="space-y-4">
                      <h3 className="text-xs font-bold text-indigo-500 uppercase tracking-widest">Gallery Extension</h3>
                      <div className="grid grid-cols-4 gap-3">
                        {existingExtraImages.map(img => (
                          <div key={img.id} className="relative aspect-square rounded-xl overflow-hidden border border-slate-100 shadow-sm group">
                            <img src={img.image_url} className="w-full h-full object-cover" alt="Extra product" />
                            <button type="button" onClick={() => deleteExtraImage(img.id)} className="absolute inset-0 bg-red-500/80 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white"><Trash2 size={16}/></button>
                          </div>
                        ))}
                        <button type="button" onClick={() => extraFilesRef.current.click()} className="aspect-square rounded-xl border-2 border-dashed border-slate-200 flex items-center justify-center text-slate-400 hover:bg-indigo-50 hover:border-indigo-200 transition-all">
                          <Plus size={20} />
                          <input type="file" multiple ref={extraFilesRef} hidden onChange={handleExtraImagesChange} />
                        </button>
                      </div>
                      {extraImagesFiles.length > 0 && (
                        <div className="text-[10px] bg-emerald-50 text-emerald-700 p-2 rounded-lg border border-emerald-100">
                          {extraImagesFiles.length} new file(s) staged for upload.
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex justify-end gap-3 pt-10 border-t border-slate-100 mt-10">
                  <button type="button" onClick={closeAndReset} className="px-6 py-2.5 text-sm font-bold text-slate-500 hover:bg-slate-100 rounded-xl transition-colors">Discard Changes</button>
                  <button type="submit" disabled={saving} className="bg-slate-900 text-white px-8 py-2.5 rounded-xl text-sm font-bold flex items-center gap-2 hover:bg-indigo-600 disabled:bg-slate-300 shadow-xl transition-all active:scale-95">
                    {saving ? <Loader2 size={18} className="animate-spin" /> : <Save size={18} />}
                    {saving ? "Publishing..." : (editingProduct ? "Update Product" : "Publish Product")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}